export const arrayUniqueBy = (field: string) => (value: Record<string, any>[]) =>
  value && value.length === new Set(value.map((v) => v[field])).size;
